// Données de démo portées telles quelles depuis la maquette
// (MyALFA Worksync Test V2/mon-poste.jsx) pour les profils Bureau qui n'ont
// pas encore d'équivalent réel dans l'app : messagerie, suivi de production
// paie mensuelle. À remplacer par de vraies données au fur et à mesure que
// ces backends existeront — voir useBureauFeed.js pour ce qui EST déjà réel
// (todos, Traitements comptables, Planning, Feuille de temps, Congés).
//
// Les tableaux ECHEANCES* ne sont PAS des données inventées : ce sont des
// échéances fiscales/sociales légales fixes (CA3, IS, CFE, DSN, SSI...).


// Profil Paie — pas de suivi de production paie mensuelle réel
// (`productionSocial`/`months[12]` de la maquette n'a pas d'équivalent) :
// quelques tâches de démo représentatives plutôt qu'une dérivation inventée.
export const PAIE_FEED_SEED = [
  { id: "bs1", client: "SECURIS", title: "Préparation BS", detail: "12 BS attendus", due: "2026-08-08", priority: "haute" },
  { id: "bs2", client: "OUTENERGIE", title: "Préparation BS", detail: "4 BS attendus", due: "2026-08-08", priority: "moyenne" },
  { id: "dsn1", client: "LA PIZZETTA", title: "Transmettre DSN", detail: "DSN mensuelle", due: "2026-08-05", priority: "haute" },
  { id: "dsn2", client: "2R Family", title: "Transmettre DSN", detail: "DSN mensuelle", due: "2026-08-05", priority: "haute" },
];

// Profil Secrétariat — pas de vrai module Leads/RDV consolidé "RDV à venir"
// exploité ici (le module Lead réel existe mais sa forme exacte de
// rendez-vous n'a pas été vérifiée pour cette v1) : liste de démo.
export const SECRETARIAT_PROSPECTS_SEED = [
  { id: "pr1", client: "NOUVELLE ACTIVITE SARL", note: "Rappel devis création société", when: "22/07" },
  { id: "pr2", client: "M. RAVELOSON", note: "RDV découverte cabinet", when: "23/07" },
  { id: "pr3", client: "SARL KOZY HOME", note: "Suite proposition LM", when: "25/07" },
];

export const SOCIAL_EVENTS = [
  { id: "se1", client: "SECURIS", type: "Entrée · Contrat de travail", when: "J-1" },
  { id: "se2", client: "LA PIZZETTA", type: "Sortie · Rupture conventionnelle", when: "J-2" },
  { id: "se3", client: "OUTENERGIE", type: "Événement · DSN Maladie / AT", when: "J-3" },
  { id: "se4", client: "2R Family", type: "Entrée · DPAE", when: "J-4" },
  { id: "se5", client: "ELANZ", type: "Sortie · Certificat de travail", when: "J-5" },
];

export const ECHEANCES = [
  { d: "2026-07-16", dEnd: "2026-07-24", cat: "TVA", label: "CA3 — TVA mensuelle (juin)" },
  { d: "2026-08-16", dEnd: "2026-08-24", cat: "TVA", label: "CA3 — TVA mensuelle (juillet)" },
  { d: "2026-09-15", cat: "IS", label: "3ᵉ acompte d'IS" },
  { d: "2026-09-15", cat: "CVAE", label: "2ᵉ acompte de CVAE" },
  { d: "2026-09-16", dEnd: "2026-09-24", cat: "TVA", label: "CA3 — TVA mensuelle (août)" },
  { d: "2026-10-05", cat: "SSI", label: "Cotisation trimestrielle SSI (T3)" },
  { d: "2026-12-15", cat: "CFE", label: "Solde CFE + acompte CFE" },
  { d: "2026-12-15", cat: "IS", label: "4ᵉ acompte d'IS" },
];

export const ECHEANCES_PAIE = [
  { d: "2026-08-05", cat: "DSN", label: "DSN mensuelle (juillet)" },
  { d: "2026-08-15", cat: "DSN", label: "DSN mensuelle — échéance décalée" },
  { d: "2026-09-05", cat: "DSN", label: "DSN mensuelle (août)" },
  { d: "2026-10-05", cat: "SSI", label: "Cotisation trimestrielle SSI (T3)" },
  { d: "2026-10-15", cat: "CP", label: "Solde des congés payés (N-1)" },
  { d: "2026-11-05", cat: "DSN", label: "DSN mensuelle (octobre)" },
];

export const ECHEANCES_JURIDIQUE = [
  { d: "2026-07-24", cat: "Greffe", label: "Dépôt des comptes — SNACK BOI ZOLY" },
  { d: "2026-07-31", cat: "AGO", label: "Approbation des comptes — clôture 31/01" },
  { d: "2026-08-15", cat: "Greffe", label: "Dépôt des comptes (dans le mois de l'AGO)" },
  { d: "2026-08-31", cat: "AGO", label: "Approbation des comptes — clôture 28/02" },
  { d: "2026-09-15", cat: "RCS", label: "Formalité de modification — dossier en cours" },
  { d: "2026-09-30", cat: "AGO", label: "Approbation des comptes — clôture 31/03" },
];

export const ECHEANCES_BY_PROFILE = { paie: ECHEANCES_PAIE, juriste: ECHEANCES_JURIDIQUE };

// RDV de démo (aucun système de planning/agenda réel n'existe encore dans
// l'app) — même forme que ce qu'un vrai calendrier exposerait un jour :
// { client, motif, date (ISO), time, canal, status }.
export const RDV_SEED = [
  { id: "rdv1", client: "EMERAUDE INVEST", motif: "Point bilan 2025", date: "2026-07-24", time: "10:00", canal: "Visio", status: "à venir" },
  { id: "rdv2", client: "SCI MAUNIER", motif: "Signature des relevés", date: "2026-07-25", time: "14:30", canal: "Cabinet", status: "à venir" },
  { id: "rdv3", client: "GARAGE DU PORT", motif: "Remise de documents", date: "2026-07-28", time: "09:15", canal: "Cabinet", status: "à venir" },
];

// Compteur de démo pour le badge "Messagerie" du raccourci — aucune
// messagerie interne n'existe encore dans l'app (contrairement à "Mails",
// désormais branché sur Gmail, voir useGmailAccount.js).
export const MESSAGERIE_UNREAD_SEED = 1;

// Prépare une source d'échéances (ECHEANCES / ECHEANCES_PAIE / ...) pour
// affichage : ne garde que les 3 prochains mois, calcule les jours restants
// et un ton (bad/warn/ok), même logique que la maquette.
export function computeEcheanceItems(source, today = new Date()) {
  const start = new Date(today);
  start.setHours(0, 0, 0, 0);
  const horizon = new Date(start);
  horizon.setMonth(horizon.getMonth() + 3);
  const MOIS_COURT = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

  return source
    .map((e) => ({ ...e, date: new Date(e.d + "T00:00:00"), endDate: e.dEnd ? new Date(e.dEnd + "T00:00:00") : null }))
    .filter((e) => (e.endDate || e.date) >= start && e.date <= horizon)
    .sort((a, b) => a.date - b.date)
    .map((e) => {
      const days = Math.round((e.date - start) / 86400000);
      const tone = days <= 7 ? "bad" : days <= 21 ? "warn" : "ok";
      const lab = e.endDate
        ? `${e.date.getDate()} - ${e.endDate.getDate()} ${MOIS_COURT[e.endDate.getMonth()]}`
        : `${e.date.getDate()} ${MOIS_COURT[e.date.getMonth()]}`;
      return { ...e, days, tone, lab };
    });
}
